module.exports = __webpack_public_path__ + "img/sku-detail-bg.b52bf07.png";